import React, { useEffect, useRef, useState } from "react";
import { Search as SearchIcon, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { SeriesCard } from "../components/SeriesCard";
import { EpisodeCard } from "../components/EpisodeCard";

export default function Search() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState({ series: [], episodes: [] });
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);

  const run = (query) => {
    setLoading(true);
    api.get(`/search`, { params: { q: query } })
      .then((r) => setRes(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => { run(""); }, []);

  const onChange = (e) => {
    const v = e.target.value;
    setQ(v);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => run(v), 300);
  };

  const hasResults = res.series?.length > 0 || res.episodes?.length > 0;

  return (
    <div className="min-h-screen grain pb-24 md:pb-12">
      <Navbar />
      <div className="max-w-[1200px] mx-auto px-4 sm:px-8 pt-28">
        <p className="text-xs tracking-[0.3em] uppercase font-bold text-blood mb-3">Discover</p>
        <div className="relative">
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" size={26} />
          <input
            autoFocus
            value={q}
            onChange={onChange}
            data-testid="search-input"
            placeholder="Search series or episodes..."
            className="w-full bg-[#111111] rounded-2xl pl-14 pr-5 py-5 sm:py-6 text-lg sm:text-2xl font-display font-semibold text-white placeholder:text-white/30 outline-none border border-white/5 focus:ring-1 focus:ring-blood focus:border-blood transition-all"
          />
        </div>

        <div className="mt-10">
          {loading && (
            <div className="flex justify-center py-16"><Loader2 className="animate-spin text-blood" size={32} /></div>
          )}

          {!loading && !q && (
            <p className="text-sm tracking-widest uppercase text-white/40 mb-5">Popular & Recently Added</p>
          )}

          {!loading && q && !hasResults && (
            <p data-testid="no-results" className="text-center text-white/50 py-16">No results for "{q}".</p>
          )}

          {!loading && res.series?.length > 0 && (
            <div className="mb-10" data-testid="search-series-results">
              {q && <p className="text-sm tracking-widest uppercase text-white/40 mb-4">Series</p>}
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5">
                {res.series.map((s, i) => <SeriesCard key={s.id} series={s} index={i} />)}
              </div>
            </div>
          )}

          {!loading && res.episodes?.length > 0 && (
            <div data-testid="search-episode-results">
              <p className="text-sm tracking-widest uppercase text-white/40 mb-4">Episodes</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {res.episodes.map((e, i) => <EpisodeCard key={e.id} episode={e} showSeries index={i} />)}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
